<app-dialog-popup #dialog>
  <div dialog-header>
    <span>Lighten's options</span>
  </div>
  <div dialog-body>
    <dt>Count:</dt>
    <dd>
      <input max="9" min="1" name="count" type="number" [ngModel]="count" (ngModelChange)="onCount($event)" />
    </dd>
  </div>
</app-dialog-popup>

<app-textarea-two inputPlaceholder="Enter your JSON here" [inputChange]="lightenNumber">
  <div header-input>
    <h2>Your heavy JSON</h2>
  </div>
  <div header-output>
    <h2>Your lighten JSON<lucide-icon name="settings" (click)="dialog.openDialog()" /></h2>
  </div>
</app-textarea-two>

<a href="https://github.com/bansan85/web-demangler">
  <app-github-mark-inline class="github_logo" />
</a>